import { Wine, Drop, Sun, Sparkle } from '@phosphor-icons/react';

// Categories data based on actual product identities from attributes.identite_produit
export const categories = [
  {
    id: 'Vin rouge',
    name: 'Vin Rouge',
    slug: 'vin-rouge',
    icon: Wine,
    subcategories: [
      { type: 'region', label: 'Provence' },
      { type: 'grape', label: 'Grenache' },
      { type: 'grape', label: 'Cinsault' },
      { type: 'grape', label: 'Mourvèdre' },
      { type: 'grape', label: 'Syrah' },
      { type: 'country', label: 'France' }
    ]
  },
  {
    id: 'Vin blanc',
    name: 'Vin Blanc',
    slug: 'vin-blanc',
    icon: Drop,
    subcategories: [
      { type: 'region', label: 'Bourgogne' },
      { type: 'grape', label: 'Chardonnay' },
      { type: 'country', label: 'France' }
    ]
  },
  {
    id: 'Champagne',
    name: 'Champagne',
    slug: 'champagne',
    icon: Sparkle,
    subcategories: [
      { type: 'region', label: 'Champagne' },
      { type: 'country', label: 'France' }
    ]
  },
  {
    id: 'Champagne rosé',
    name: 'Champagne Rosé',
    slug: 'champagne-rose',
    icon: Sparkle,
    subcategories: [
      { type: 'region', label: 'Champagne' },
      { type: 'country', label: 'France' }
    ]
  },
  {
    id: 'Vin rosé',
    name: 'Vin Rosé',
    slug: 'vin-rose',
    icon: Wine,
    subcategories: [
      { type: 'region', label: 'Provence' },
      { type: 'grape', label: 'Grenache' },
      { type: 'grape', label: 'Cinsault' },
      { type: 'country', label: 'France' }
    ]
  }
];

// Helper function to get category by slug
export const getCategoryBySlug = (slug) => {
  return categories.find(cat => cat.slug === slug);
};

// Helper function to get category by ID (product identity)
export const getCategoryById = (id) => {
  return categories.find(cat => cat.id === id);
};

// Helper function to get all product identities for filtering
export const getProductIdentities = () => {
  return categories.map(cat => cat.id);
};

// Helper function to get the correct Algolia attribute for filtering
export const getFilterAttribute = (type) => {
  const attributeMap = {
    'region': 'attributes.region_origine',
    'grape': 'attributes.cepage',
    'country': 'attributes.pays_origine'
  };
  return attributeMap[type] || 'attributes.identite_produit';
}; 